// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"354":"9c4ac4f3","700":"9c4ac4f3","738":"9c4ac4f3","927":"c005bcba"}[chunkId] + ".chunk.css";
};